import './NeedyKnobModule.css';
import needyKnob from './img/knob.png';

function NeedyKnobModule() {

    return (
        <div>
            <h3>Needy Knob</h3>
            <img src={needyKnob} width="100%" alt="glyphs" />
        </div>
    );
}

export default NeedyKnobModule;
